import $ from 'jquery';

$(document).on('change', '#filter', function (e) {
    let value = $('#filter').val().toString();
    let collection_name = $('.collection-filter__nav-link.selected').attr('id');
    console.log(collection_name)
    if(value === 'sets' || value === 'singles'){
         $.ajax({
             type: "get",
             url: `${window.language}/collections/${collection_name}?view=${value}`,
            success: (response) => {
                 if(response){
                     $('.collection-products__grid').html(response);
                 }
            },
        });
    }else{
        window.location.href = `?sort_by=${value}`;
    }
})
